import { IItem } from './grpc.interfaces';

export interface IClusterData {
  name: string;
  position: number;
}

export type ClusterItem = IItem<IClusterData>;

export enum LocationType {
  City = 'city',
  Cluster = 'cluster',
}
